import {retrieveLangs} from "../languages/actions";
import {retrieveRequestFactory, putRequestFactory} from 'store/generic/actions';


import {UPDATE_ITEMS, ADD_ITEM, DELETE_ITEM, EDIT_ITEM} from "../generic/actions";

export const COLLECTION_NAME = 'package';
const PACKAGES_SUFFIX = '_' + COLLECTION_NAME.toUpperCase();
export const UPDATE_PACKAGES = UPDATE_ITEMS + PACKAGES_SUFFIX;
export const ADD_PACKAGE = ADD_ITEM + PACKAGES_SUFFIX;
export const DELETE_PACKAGE = DELETE_ITEM + PACKAGES_SUFFIX;
export const EDIT_PACKAGE = EDIT_ITEM + PACKAGES_SUFFIX;


const emptyPackage = {
        name: null,
        published: false,
        permission: 4,
        description: null,
        difficulty: null,
        id: null,
    };


export const updatePackages = (payload) => ({
    type: UPDATE_PACKAGES,
    version: payload.version,
    changed_items: payload.packages
});


export const addPackage = (pckg) => ({
    type: ADD_PACKAGE,
    item: {...emptyPackage, ...pckg},
});

export const deletePackage = (pckg) => ({
    type: DELETE_PACKAGE,
    item: pckg
});

export const editPackage = (pckg, changes) => ({
    type: EDIT_PACKAGE,
    item: pckg,
    changes: changes
});

const _retrievePackages = retrieveRequestFactory('packages', COLLECTION_NAME, true, updatePackages);

export const retrievePackages = () => (
    (dispatch, getState) => {
        const state = getState();
        if (state.lang.languages.length === 0) {
            dispatch(retrieveLangs()).then(() => {
                dispatch(_retrievePackages());
            })
        }
        else {
            dispatch(retrieveLangs());
            dispatch(_retrievePackages());
        }
    }

);


export const putPackages = () => (
    (dispatch, getState) => {
        const state = getState();
        return dispatch(putRequestFactory('packages', {packages: state.package.put}, COLLECTION_NAME)());
    }
);


// export const syncPackages = () => (
//     (dispatch, getState) => {
//         return dispatch(putPackages())//.then(dispatch(retrievePackages()));
//     }
// );




// WEBPACK FOOTER //
// ./src/store/packages/actions.js